<template>
  <div class="payment-result"></div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {
    this.$router.replace(`/giveFriends?stats=${this.$route.query.status}&orderId=${this.$route.query.orderId}&from=pay`)
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
